import Fetcher from '../../utility/Fetcher';
import DataStore from '../../stores/DataStore';
import { FetchingModel, ModelDataUpdate, InvalidCadastreKeySubmitted, Unauthorized, GenericError } from '../../Events';
import ErrorHandler from '../../utility/ErrorHandler';

export function init(tag: any): void {
  const onFetch = () => {
    tag.loading = true;
    tag.update();
  };
  const onReceive = () => {
    tag.loading = false;
    tag.update();
  };
  tag.on('mount', () => {
    Fetcher.addListener(FetchingModel, onFetch);
    DataStore.addListener(ModelDataUpdate, onReceive);
    ErrorHandler.addListener(InvalidCadastreKeySubmitted, onReceive);
    ErrorHandler.addListener(Unauthorized, onReceive);
    ErrorHandler.addListener(GenericError, onReceive);
  });
  tag.on('unmount', () => {
    Fetcher.removeListener(FetchingModel, onFetch);
    DataStore.removeListener(ModelDataUpdate, onReceive);
    ErrorHandler.removeListener(InvalidCadastreKeySubmitted, onReceive);
    ErrorHandler.removeListener(Unauthorized, onReceive);
    ErrorHandler.removeListener(GenericError, onReceive);
  });
}



/** WEBPACK FOOTER **
 ** ./src/components/loadingIndicator/LoadingIndicatorController.ts
 **/